import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface UserTableModal2Props {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const UserTableModal2: FC<UserTableModal2Props> = ({ user, onClose, show }) => {
    // console.log("user in UserTableModal2", user)

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_payment'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Payment Details</h1>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr className="fw-bold text-muted bg-light" >
                                    <th className="min-w-150px ps-4">Advance (INR)</th>
                                    <th className="min-w-150px">UTR Number</th>
                                    <th className="min-w-150px rounded-end">PO Copy</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="ps-4">
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.paymentInfo?.amount || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.paymentInfo?.paymentId || 'N/A'}
                                        </span>
                                    </td>


                                    <td>
                                        {user?.paymentInfo?.images?.[0]?.docUrl ? (
                                            <i
                                                className="bi bi-file-pdf text-danger cursor-pointer"
                                                style={{ fontSize: '3rem' }}
                                                onClick={() => window.open(user.paymentInfo.images[0].docUrl, '_blank')}
                                                title="View PDF"
                                            ></i>
                                        ) : (
                                            'N/A'
                                        )}
                                    </td>


                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};